


import { POST } from "../API";
let source = null;

export const createGroupAPI = (data, onSuccess, onError) => {
    source = POST(`/api/v1/chat/groups/create`, data, onSuccess, onError, true, source);
};
